import React, {Dispatch, FC, SetStateAction} from 'react';
import {UploadFile} from "antd/es/upload";
import {defineMessages, useIntl} from "react-intl";
import {CustomModal} from "../../../../components/UI/AntCustom/CustomModal";


const RegistrationLicensesModalMessages = defineMessages({
  title: {
    id: "registrationLicensesModal.title",
    defaultMessage: "User licenses"
  },
  warn: {
    id: "registrationLicensesModal.warn",
    defaultMessage: "User hasn't uploaded any files yet."
  },
  operatorCertificate: {
    id: "registrationLicensesModal.operatorCertificate",
    defaultMessage: "AOC"
  },
  registrationCertificate: {
    id: "registrationLicensesModal.registrationCertificate",
    defaultMessage: "Certificate of incorporation"
  },
  caaOperatorApproval: {
    id: "registrationLicensesModal.caaOperatorApproval",
    defaultMessage: "CAA operator approval to operate international flights"
  },
  easaTcoAuthorisation: {
    id: "registrationLicensesModal.easaTcoAuthorisation",
    defaultMessage: "EU: EASA TCO authorisation"
  },
  faaAuthorization: {
    id: "registrationLicensesModal.faaAuthorization",
    defaultMessage: "US: FAA authorization"
  },
})

interface RegistrationLicensesModalProps {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  operatorCard?: UploadFile;
  registrationCertificate?: UploadFile;
  // International Flights documents
  caaOperatorApproval?: UploadFile;
  easaTcoAuthorisation?: UploadFile;
  faaAuthorization?: UploadFile;
}

export const RegistrationLicensesModal: FC<RegistrationLicensesModalProps> = ({
  isVisible,
  setIsVisible,
  operatorCard,
  registrationCertificate,
  caaOperatorApproval,
  easaTcoAuthorisation,
  faaAuthorization
}) => {
  const intl = useIntl();

  const hasAnyFile = operatorCard || registrationCertificate || 
                     caaOperatorApproval || easaTcoAuthorisation || faaAuthorization;

  return (
    <CustomModal
      title={intl.formatMessage(RegistrationLicensesModalMessages.title)}
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      centered
      footer={null}
    >
      {!hasAnyFile && intl.formatMessage(RegistrationLicensesModalMessages.warn)}
      <ul>
        {operatorCard &&
          <li key={operatorCard.uid}>
            {intl.formatMessage(RegistrationLicensesModalMessages.operatorCertificate)}: <a href={operatorCard.url} target={'_blank'} rel="noreferrer">{operatorCard.name}</a>
          </li>}

        {registrationCertificate &&
          <li key={registrationCertificate.uid}>
            {intl.formatMessage(RegistrationLicensesModalMessages.registrationCertificate)}: <a href={registrationCertificate.url} target={'_blank'} rel="noreferrer">{registrationCertificate.name}</a>
          </li>}

        {caaOperatorApproval &&
          <li key={caaOperatorApproval.uid}>
            {intl.formatMessage(RegistrationLicensesModalMessages.caaOperatorApproval)}: <a href={caaOperatorApproval.url} target={'_blank'} rel="noreferrer">{caaOperatorApproval.name}</a>
          </li>}

        {easaTcoAuthorisation &&
          <li key={easaTcoAuthorisation.uid}>
            {intl.formatMessage(RegistrationLicensesModalMessages.easaTcoAuthorisation)}: <a href={easaTcoAuthorisation.url} target={'_blank'} rel="noreferrer">{easaTcoAuthorisation.name}</a>
          </li>}

        {faaAuthorization &&
          <li key={faaAuthorization.uid}>
            {intl.formatMessage(RegistrationLicensesModalMessages.faaAuthorization)}: <a href={faaAuthorization.url} target={'_blank'} rel="noreferrer">{faaAuthorization.name}</a>
          </li>}
      </ul>
    </CustomModal>
  );
};
